(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(()=> {
  const details = document.getElementById('ptsBuyMenu');
  if (!details) return;

  const panel = details.querySelector('.pts-buy__panel');
  const mqMobile = window.matchMedia('(max-width: 749px)');

  const resetDesktop = () => {
    if (!panel) return;
    panel.style.position = '';
    panel.style.top = '';
    panel.style.left = '';
    panel.style.right = '';
    panel.style.transform = '';
    panel.style.width = '';
    panel.style.maxWidth = '';
  };

  const placeMobile = () => {
    if (!panel) return;
    const headerWrap = document.querySelector('.section-header .header-wrapper') || document.querySelector('.section-header');
    const r = headerWrap ? headerWrap.getBoundingClientRect() : details.getBoundingClientRect();
    const w = Math.min(350, Math.max(280, window.innerWidth - 24));

    panel.style.position = 'fixed';
    panel.style.top = `${Math.round(r.bottom + 10)}px`;
    panel.style.left = '50%';
    panel.style.right = 'auto';
    panel.style.transform = 'translateX(-50%)';
    panel.style.width = `${w}px`;
    panel.style.maxWidth = 'unset';
  };

  const apply = () => {
    if (!panel) return;
    if (mqMobile.matches) placeMobile();
    else resetDesktop();
  };

  const close = () => details.removeAttribute('open');

  let raf = 0;
  const scheduleApply = () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  };

  details.addEventListener('toggle', () => {
    if (details.open) apply();
  });

  window.addEventListener('resize', scheduleApply, { passive: true });

  if (mqMobile.addEventListener) mqMobile.addEventListener('change', scheduleApply);
  else if (mqMobile.addListener) mqMobile.addListener(scheduleApply);

  document.addEventListener('click', (e) => {
    if (details.open && !details.contains(e.target)) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && details.open) close();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
